import { SETTINGS_PAGES } from './settings.constants';

export const getDefaultTab = (type: string) => {
  switch (type) {
    case SETTINGS_PAGES.editCompanyProfile:
      return SETTINGS_PAGES.companyProfile;
    case SETTINGS_PAGES.permissionGroupsEdit:
      return SETTINGS_PAGES.permissionGroup;
    case SETTINGS_PAGES.editDatev:
    case SETTINGS_PAGES.editConsultantNumber:
      return SETTINGS_PAGES.payrollAccounting;
    default:
      return type;
  }
};
